import axios from 'axios'
import jwtDecode from 'jwt-decode'
import dayjs from 'dayjs'

import { fetchUserData } from 'store/user/actions'
import settings from './settings'
import { generalStore } from './index'

export const getAccessToken = async () => {
	const accessToken = localStorage.getItem('accessToken')
	const refreshToken = localStorage.getItem('refreshToken')
	let accessTokenHasExpired
	let refreshTokenHasExpired

	const currentUrl = new URL(window.location.href)

	// quickAuth could contain a very short-lived refreshToken so that we can "quickAuth" into customer web from
	// other authenticated sources.
	let quickAuthRefreshToken = currentUrl.searchParams.get('quickAuth')
	currentUrl.searchParams.delete('quickAuth')

	window.history.replaceState(null, '', currentUrl.href)

	if (quickAuthRefreshToken) {
		const parsedQuickAuthRefreshToken = jwtDecode(quickAuthRefreshToken)
		const quickAuthRefreshTokenHasExpired = parsedQuickAuthRefreshToken.exp - dayjs().unix() <= 0
		if (quickAuthRefreshTokenHasExpired) {
			quickAuthRefreshToken = null
		}
	}

	if (!quickAuthRefreshToken) {
		if (accessToken && refreshToken) {
			const parsedAccessToken = jwtDecode(accessToken)
			const parsedRefreshToken = jwtDecode(refreshToken)
			accessTokenHasExpired = parsedAccessToken.exp - dayjs().unix() <= 0
			refreshTokenHasExpired = parsedRefreshToken.exp - dayjs().unix() <= 0
		} else {
			console.log('Not logged in')
			return null
		}
		if (refreshTokenHasExpired) {
			console.log('Refresh token has expired')
			localStorage.removeItem('accessToken')
			localStorage.removeItem('refreshToken')
			return null
		}
	}

	if (accessTokenHasExpired || quickAuthRefreshToken) {
		let refreshTokenToUse = refreshToken
		if (quickAuthRefreshToken) {
			refreshTokenToUse = quickAuthRefreshToken
		}
		const axiosInstanceWithoutInterceptor = axios.create()
		let refreshResponse = await axiosInstanceWithoutInterceptor.post(
			`${settings.kreaBaseUrl}/api/v1/auth/refresh-token`,
			{
				refresh_token: refreshTokenToUse
			}
		)
		localStorage.setItem('accessToken', refreshResponse.data.access_token)
		localStorage.setItem('refreshToken', refreshResponse.data.refresh_token)

		// Update userReducer
		generalStore.dispatch(fetchUserData())
	}
	const currentAccessToken = localStorage.getItem('accessToken')

	if (currentAccessToken) {
		return currentAccessToken
	}
	return null
}

export default class HttpService {
	static instance
	static getInstance() {
		if (HttpService.instance) {
			return HttpService.instance
		}
		HttpService.instance = new HttpService()
		return HttpService.instance
	}
	setupInterceptors() {
		axios.defaults.withCredentials = false // otherwise axios seems to send session-cookie credentials SOMETIMES

		axios.interceptors.response.use(
			(response) => {
				return response
			},
			(error) => {
				return Promise.reject(error.response)
			}
		)

		axios.interceptors.request.use(
			async (config) => {
				const currentAccessToken = await getAccessToken()
				config.headers.Authorization = currentAccessToken ? 'Bearer ' + currentAccessToken : null

				const params = new URLSearchParams(window.location.search)
				let auth = params.get('auth')
				if (auth) {
					config.params = { ...params, auth }
				}
				return config
			},
			(error) => {
				// Do something with request error
				return Promise.reject(error)
			}
		)
	}
}
